// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".slide-enter-active[data-v-2ae5bc02],.slide-leave-active[data-v-2ae5bc02]{transition:all .5s ease}.slide-enter[data-v-2ae5bc02],.slide-leave-to[data-v-2ae5bc02]{transform:translateX(-100%);opacity:0}[data-v-2ae5bc02]::-webkit-scrollbar{display:none}.search-result[data-v-2ae5bc02]{height:100%;width:100%;display:flex}@media(max-width:960px),(min-width:961px)and (max-width:1200px){.search-result[data-v-2ae5bc02]{position:relative;flex-direction:column}}", ""]);
// Exports
module.exports = exports;
